// Legacy bridge - lets code outside the React tree (e.g. the axios interceptor)
// trigger snackbars via the ref registered by SnackbarProvider.

export interface SnackbarRef {
  showMessage: (message: string, severity?: string | null) => void;
  showSuccess: (message: string) => void;
  showError: (message: string) => void;
  showWarning: (message: string) => void;
  showInfo: (message: string) => void;
  close: () => void;
}

let snackbarRef: SnackbarRef | null = null;

export const setSnackbarRef = (ref: SnackbarRef | null) => {
  snackbarRef = ref;
};

export const snackbarUtils = {
  showMessage: (message: string, severity: string | null = null) => {
    if (snackbarRef) {
      snackbarRef.showMessage(message, severity);
    } else {
      console.warn("Snackbar not initialized. Use useSnackbar hook instead.");
    }
  },

  showSuccess: (message: string) => {
    snackbarRef?.showSuccess(message);
  },

  showError: (message: string) => {
    snackbarRef?.showError(message);
  },

  showWarning: (message: string) => {
    snackbarRef?.showWarning(message);
  },

  showInfo: (message: string) => {
    snackbarRef?.showInfo(message);
  },

  close: () => {
    snackbarRef?.close();
  },
};
